export const CORE_STATE_DRAFT = 'Draft';
export const CORE_STATE_SUBMITTED = 'Submitted';
export const CORE_STATE_CLOSED = 'Closed';
export const SUPER_USER_ROLE = 'OIRSENG';
export const SUPER_USER_RO_ROLE = 'ERMSRO';

// Changing these values requires updating the relevant security policies that
// manage access and modification to catalog management submissions.
export const SMO_TEAM_NAME = 'SMO';
export const CATALOG_TECHNICAL_OWNERS_TEAM_NAME = 'Catalog Technical Owners';
export const CATALOG_BUSINESS_OWNERS_TEAM_NAME = 'Catalog Business Owners';
// These values MUST match what the security policy uses to determine if the
// record is locked.
export const REVISION_LOCK_TIME = 25 * 60 * 1000;
export const REVISION_LOCK_PROMPT_TIME = 3 * 60 * 1000;

// Misc Constants
export const POPULAR_FORMS_CATEGORY_SLUG = 'popular-services';
export const SETTINGS_LABEL = 'Admin Tools';

// Class names
export const DEFAULT_LABEL_CLASS = 'status--default';
export const WARNING_LABEL_CLASS = 'status--warning';
export const SUCCESS_LABEL_CLASS = 'status--success';
export const DANGER_LABEL_CLASS = 'status--danger';

export const KAPP_SLUG_ERMS = 'erms';
// Services (ERMS) Forms
export const FORM_SLUG_HELP = 'help';
export const FORM_SLUG_FEEDBACK = 'feedback';
export const FORM_SLUG_ISSUE = 'general-request-or-issue-sd-0105';
export const FORM_SLUG_AGENCY_ISSUE = 'agency-general-request-or-issue-sd-0143';
export const FORM_SLUG_COMMENT = 'comment';
export const FORM_SLUG_CONFIRM_SUCCESS = 'confirm-request-success';
export const FORM_SLUG_CANCEL = 'cancel-request-standard';
export const FORM_SLUG_ESCALATE = 'escalation-sd-0072';
export const FORM_SLUG_ISSUE_CREATE = 'issue-create';
export const FORM_SLUG_CALL_LOG = 'service-desk-call-log-documentation-sd-0091';
export const FORM_SLUG_SHARED_RESOURCES = 'shared-resources';
export const FORM_SLUG_EDIT_MEDIA_SANITATION = 'action-dcfg-media-sanitation';
export const FORM_SLUG_PORTAL_ROLE_REQUEST = 'portal-role-request';
export const FORM_SLUG_NO_ACCESS = 'no-access';
export const FORM_SLUG_SLA_PORTAL = 'sla-portal';
export const FORM_SLUG_CATALOG_FEEDBACK = 'catalog-item-feedback';
export const FORM_SLUG_CATALOG_CHANGE_REQUEST = 'catalog-change-request';
export const FORM_SLUG_MAINTENANCE_SCHEDULE = 'maintenance-schedule';
export const FORM_SLUG_SITE_MAINTENANCE = 'site-maintenance';
export const FORM_SLUG_REPORT_SITE_ISSUE = 'modal-report-site-issue';

export const KAPP_SLUG_DATASTORE = 'datastore';
// Datastore Forms
export const FORM_SLUG_PORTFOLIO = 'portfolio';
export const FORM_SLUG_SERVICE = 'service';
export const FORM_SLUG_APPENDIX = 'appendix';

export const KAPP_SLUG_ADMIN = 'admin';
// Admin Forms
export const FORM_SLUG_RATE_CARD = 'rate-card';
export const FORM_SLUG_NEWS = 'news';
export const FORM_SLUG_DATA_CENTER_STATUS = 'data-center-status';
export const FORM_SLUG_FORM_APPROVALS = 'form-approvals';
export const FORM_SLUG_EXTERNAL_SERVICE_OFFERINGS =
  'external-service-offerings';

// WebAPIs
export const WEBAPI_SYNC_SERVICE_CATEGORIES = 'sync-service-categories';

// Generic Attributes
export const ATTR_ICON = 'Icon';
export const ATTR_IMAGE = 'Image';
export const ATTR_KEYWORD = 'Keyword';
export const ATTR_HIDDEN = 'Hidden';
export const ATTR_PARENT = 'Parent';
export const ATTR_SORT_ORDER = 'Sort Order';
export const ATTR_STATUSES_ACTIVE = 'Statuses - Active';
export const ATTR_STATUSES_INACTIVE = 'Statuses - Inactive';
export const ATTR_STATUSES_CANCELLED = 'Statuses - Cancelled';

// Form Attributes
export const FORM_ATTR_CLONEABLE = 'Cloneable';
export const FORM_ATTR_FUNDING_DEPENDENT = 'Funding Dependent';
export const FORM_ATTR_APPROVALS = 'Approvals';
export const FORM_ATTR_CANCEL_TEMPLATE = 'Cancel Template';
export const FORM_ATTR_CANCELABLE = 'Cancelable';
export const FORM_ATTR_IS_MENU_LINK = 'Add To Menu';
export const FORM_ATTR_PAGE_GROUP_NAME = 'Page Group Name';
export const FORM_ATTR_PAGE_SORT_ORDER = 'Page Sort Order';
export const FORM_ATTR_EXCLUDE_ESCALATE_FORM = 'Exclude Escalate Button';
export const FORM_ATTR_EXCLUDE_ISSUE_BUTTON = 'Exclude Issue Button';
export const FORM_ATTR_TRACKED_DUPLICATE_BUTTON = 'Tracked Duplicate Button';
export const FORM_ATTR_INTERNAL = 'Internal';
export const FORM_ATTR_SLT = 'SLT';
export const FORM_ATTR_PVG_OVERRIDE = 'PVG Override';
export const FORM_ATTR_MAINTENANCE = 'Maintenance';
export const FORM_ATTR_EXCLUDE_REQUEST_REVIEW = 'Exclude Request Review';
export const FORM_ATTR_EXCLUDE_REPORT_SITE_ISSUE = 'Exclude Report Issue Link';
export const FORM_ATTR_EXCLUDE_FROM_SEARCH = 'Exclude From Search Results';

// User Attributes
export const ATTRIBUTE_USER_EAUTH_ASSURANCE_LEVEL = 'EAuth Assurance Level';
export const ATTRIBUTE_USER_AGREEMENTS = 'Portal Roles';
export const ATTRIBUTE_USER_AGREEMENTS_EXTRA = 'Add Portal Roles';
export const ATTRIBUTE_USER_EAUTH_AGENCIES = 'Employee Status';
export const ATTRIBUTE_USER_EAUTH_AGENCIES_EXTRA = 'Add EAuth Agencies';
export const ATTRIBUTE_USER_FIRST_NAME = 'First Name';
export const ATTRIBUTE_USER_LAST_NAME = 'Last Name';
export const ATTRIBUTE_USER_REMEDY_LOGIN_ID = 'Remedy Login ID';
export const ATTRIBUTE_USER_APPROVAL_ADMIN = 'Master Approval Manager';
export const ATTRIBUTE_USER_COMPANY = 'Company';
export const ATTRIBUTE_USER_STAFF_SELECTION_FILTER = 'Staff Selection Filter';
export const ATTRIBUTE_USER_PROFILE_REQUEST_VIEW_MODE = 'Request View Mode';
export const ATTRIBUTE_USER_PROFILE_FAVORITES = 'Favorites';
export const ATTRIBUTE_USER_PROFILE_ALTERNATES = 'Alternates';
export const ATTRIBUTE_USER_PROFILE_NEW_FORM_NOTIFICATION =
  'New Form Notification';

// Kapp Attributes
export const ATTRIBUTE_KAPP_SHOW_EMPTY_CATEGORIES = 'Show Empty Categories';
export const ATTRIBUTE_KAPP_DEFAULT_FORM_IMAGE = 'Default Form Image';

// Space Attributes
export const ATTRIBUTE_SPACE_TEAM_PREFIXES = 'Team Prefixes';
export const SPACE_ATTR_ENVIRONMENT = 'Environment';
export const SPACE_ATTR_DEFAULT_NEWS_IMAGE = 'Default News Image';
export const SPACE_ATTR_ITSM_WEB_URL = 'ITSM Web URL';
export const SPACE_ATTR_ITSM_WEB_URL_COMPANIES = 'ITSM Web URL Companies';
export const SPACE_ATTR_MONITORING_URL = 'System Monitoring URL';
export const SPACE_ATTR_EMS_CUSTOMER_PORTAL_URL = 'EMS Customer Portal URL';
export const SPACE_ATTR_EAUTH_URL = 'eAuth Role Maintenance URL';
export const SPACE_USER_EAUTH_ASSURANCE_WHITE_LIST =
  'EAuth Assurance White List';
export const SPACE_ATTR_AGENCY_CODES = 'Agency Codes';
export const SPACE_ATTR_SITE_MAINTENANCE = 'Site Maintenance';

// Fields
export const FIELD_ACTION_DETAILS = 'Details';
export const FIELD_ACTION_SUBMITTER_NAME = 'Submitter Display Name';
export const FIELD_ACTION_SUMMARY = 'Summary';
export const FIELD_AGREEMENT = 'Agreement';
export const FIELD_APPROVAL_DETAILS = 'Details';
export const FIELD_APPROVAL_NUMBER_NEEDED = 'Number of Approvals Needed';
export const FIELD_APPROVAL_NUMBER_RECEIVED = 'Number of Approvals Received';
export const FIELD_APPROVAL_SUBMITTER_NAME = 'Submitter Display Name';
export const FIELD_APPROVAL_SUMMARY = 'Summary';
export const FIELD_APPROVAL_USERNAMES = 'Approval Usernames';
export const FIELD_ASSIGNED_INDIVIDUAL = 'Assigned Individual';
export const FIELD_ASSIGNED_INDIVIDUAL_NAME =
  'Assigned Individual Display Name';
export const FIELD_ASSIGNED_INDIVIDUALS = 'Assigned Individuals';
export const FIELD_ASSIGNED_TEAM = 'Assigned Team';
export const FIELD_ASSIGNED_TEAM_NAME = 'Assigned Team Display Name';
export const FIELD_ASSIGNED_TEAMS = 'Assigned Teams';
export const FIELD_CANCEL_TEMPLATE = 'sa-Cancel Template';
export const FIELD_CANCELABLE = 'sa-Cancelable';
// export const FIELD_CHANGE_NUMBERS = 'sa-CRQ Number'; // Deprecated Field
export const FIELD_COMPLETED_BY_NAME = 'Completed By Full Name';
export const FIELD_CONFIRM_SUCCESS = 'sa-Success Response';
export const FIELD_DUE_DATE = 'Due Date';
export const FIELD_EXPIRATION_DATE = 'Expiration Date';
// export const FIELD_INCIDENT_NUMBERS = 'sa-INC Number'; // Deprecated Field
export const FIELD_IS_LEGACY = 'Is Legacy';
export const FIELD_PROGRESS = 'sa-Progress';
export const FIELD_PROJECT = 'Project';
export const FIELD_PVG_OVERRIDE_DEFERRAL = 'sa-PVG Override Deferral';
export const FIELD_RELATED_DEFERRAL_TOKEN = 'Related Deferral Token';
export const FIELD_RELATED_SUBMISSION_ID = 'Related Submission Id';
export const FIELD_RELATED_TICKET_ID = 'Related Ticket Id';
export const FIELD_REFERRING_ID = 'Referring Id';
export const FIELD_REQUEST_FORM_NAME = 'Request Form Name';
export const FIELD_REQUEST_FORM_SLUG = 'Request Form Slug';
export const FIELD_REQUEST_SUBMISSION_ID = 'Request Submission Id';
export const FIELD_REQUESTED_BY = 'Requested By';
export const FIELD_REQUESTED_BY_NAME = 'sa-Submitter Name';
export const FIELD_REQUESTED_FOR = 'Requested For';
export const FIELD_REQUESTED_FOR_NAME = 'Requested For Full Name';
// export const FIELD_SERVER_NAME = 'sa-Server Name'; // Deprecated Field
export const FIELD_SERVER_NAMES = 'sa-Server Names';
export const FIELD_SLT = 'sa-SLT';
export const FIELD_STATUS = 'Status';
export const FIELD_SUBMISSION_ORIGIN = 'sa-Submission Origin';
export const FIELD_SUBMITTER = 'Submitter';
export const FIELD_SUMMARY = 'Summary';
export const FIELD_TICKET_NUMBERS = 'sa-Ticket Numbers';
export const FIELD_TRACKING_NUMBER = 'sa-Customer Tracking Number';

// Datastore Fields
export const FIELD_APPENDIX_ID = 'Appendix Id';
export const FIELD_PORTFOLIO_ID = 'Portfolio Id';
export const FIELD_RATE_CODE = 'Rate Code';
export const FIELD_SERVICE_ID = 'Service Id';

// Default Icons
export const ICON_CATEGORY = 'fa fa-folder';
export const ICON_PORTFOLIO = 'fa fa-box';
export const ICON_SERVICE = 'fa fa-folder';
export const ICON_REQUEST = 'fa fa-ticket-alt';
export const ICON_APPROVAL = 'fa fa-clipboard-check';
export const ICON_ACTION = 'fa fa-tasks';
export const ICON_APPENDIX = 'fa fa-paperclip';

// Field Groups
export const PORTFOLIO_PRIMARY_FIELDS = [
  FIELD_PORTFOLIO_ID,
  FIELD_STATUS,
  'Type',
  'Name',
  'Short Description',
  'Portfolio Owners',
  'Technical Owners',
  'Business Owners',
  'Icon',
  'Locked By',
  'Sort Priority',
];
export const SERVICE_PRIMARY_FIELDS = [
  FIELD_SERVICE_ID,
  FIELD_STATUS,
  'Type',
  'Name',
  'Short Description',
  'Service Owners',
  'Technical Owners',
  'Business Owners',
  'Icon',
  'Locked By',
  'Sort Priority',
  FIELD_PORTFOLIO_ID,
  FIELD_APPENDIX_ID,
  FIELD_RATE_CODE,
];
export const APPENDIX_PRIMARY_FIELDS = [
  FIELD_APPENDIX_ID,
  FIELD_STATUS,
  'Type',
  'Name',
  'Short Description',
  'Icon',
  'Locked By',
];

export const MAIN_USER_ATTRIBUTES = [ATTRIBUTE_USER_COMPANY];

// Values
export const HIDE_PROGRESS_STATUSES = [
  'Cancellation In Progress',
  'Cancellation in Progress',
  'Cancelled',
  'Completed',
  'Closed',
];
export const PORTAL_PAGE_FORM_TYPE = 'Portal Page';
export const PORTAL_PAGE_STATUSES = ['New', 'Active'];
export const REQUEST_FORM_TYPE = 'Service';
export const REQUEST_FORM_STATUSES = ['New', 'Active'];
export const UTILITY_FORM_TYPE = 'Utility';
export const APPROVAL_FORM_TYPE = 'Approval';
export const ACTION_FORM_TYPE = 'Action';
export const ISSUE_FORM_TYPE = 'Issue';
export const SURVEY_FORM_TYPE = 'Survey';
export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50, 100];
export const RSS_SUBSCRIBE_URL =
  'https://public.govdelivery.com/accounts/USDAOCIO/subscriber/new';
export const RSS_DATA_CENTER_STATUS_URL =
  'https://public.govdelivery.com/topics/USDAOCIO_46/feed.rss';
export const RSS_MAINTENANCE_SCHEDULE_URL =
  'https://public.govdelivery.com/topics/USDAOCIO_47/feed.rss';

// Utility forms
export const HELP_FORM_CONFIG = {
  formSlug: FORM_SLUG_HELP,
  title: 'Get Help',
  confirmationMessage: "We'll get you a response as soon as possible.",
};
export const FEEDBACK_FORM_CONFIG = {
  formSlug: FORM_SLUG_FEEDBACK,
  title: 'Provide Feedback',
  confirmationMessage:
    "Thanks for your feedback. We'll get that routed to the right team.",
};
export const COMMENT_FORM_CONFIG = {
  formSlug: FORM_SLUG_COMMENT,
  title: 'Add Comment',
  confirmationMessage: 'Your comment has been submitted.',
};
export const CANCEL_FORM_CONFIG = {
  title: 'Cancel Request',
  confirmationMessage: 'Your cancellation request has been submitted.',
};
export const CONFIRM_SUCCESS_FORM_CONFIG = {
  formSlug: FORM_SLUG_CONFIRM_SUCCESS,
  title: 'Report Success/Failure',
  confirmationMessage: 'Your success confirmation has been submitted.',
};
export const ESCALATE_FORM_CONFIG = {
  formSlug: FORM_SLUG_ESCALATE,
  title: 'Escalate Request',
  confirmationMessage: 'Your escalation request has been submitted.',
};
export const PVG_OVERRIDE_FORM_CONFIG = {
  title: 'PVG Quorum Approval Override',
  confirmationMessage: 'Your override has been submitted.',
};
export const ISSUE_CREATE_FORM_CONFIG = {
  formSlug: FORM_SLUG_ISSUE_CREATE,
  title: 'Add Issue',
  confirmationMessage: 'Your issue has been submitted.',
};
export const ISSUE_RESOLVE_FORM_CONFIG = {
  title: 'Resolve Issue',
  confirmationMessage: 'Your issue has been updated.',
};
